<template>
    <DForm @submit.prevent="submitForm">
        <div
            v-for="(translation, key) in translations"
            :key="key"
        >
            <DCard
                padding
                :title="defaultLanguageLabel(translation)"
                class="mb-3"
            >
                <DFormRow
                    :label="__('settings.tax_rules.form.invoice_text')"
                    :hint="__('settings.brands.form.postal.invoice_text.translation_hint')"
                >
                    <DFormTextarea
                        id="postal_invoice_text"
                        v-model="form.translations[key].postal_invoice_text.value"
                        :is-valid="isFormFieldValid('postal_invoice_text')"
                    />
                </DFormRow>
            </DCard>
        </div>
        <DFormControls
            :cancel-route="$route('settings.brands.index')"
            @submit="submitForm"
        />
    </DForm>
</template>

<script setup>
import { route } from '~@/Composables/route'
import { useForm } from '@inertiajs/vue3'
import { __ } from '~@/Composables/translation'

const props = defineProps({
    brand: {
        type: Object,
        default: () => {
            return {}
        }
    },
    translations: {
        type: Object,
        default: () => {
            return {}
        }
    },
    defaultTenantLanguage: {
        type: String,
        default: ''
    }
})

const form = useForm({
    translations: props.translations
})

const submitForm = () => {
    form.post(route('settings.brands.translations-update', { brand: props.brand.id ?? 0 }))
}
const defaultLanguageLabel = (translation) => props.defaultTenantLanguage.value === translation.language.value ? `${__('settings.default_customer_language')} ${translation.language.label}` : translation.language.label

</script>

<style scoped lang="scss">

</style>
